import { Table } from '@monorepo/shared/componentsV2/Table/Table';
import styled from 'styled-components';

export const DocumentsTable = styled(Table)`
  height: 100%;
  padding-bottom: 4rem;
` as typeof Table;

const GAP = '0.4rem';
const CHEVRON_SLOT_WIDTH = '1.5rem';
const ICON_SIZE = '1.25rem';

export const DOCUMENT_CHILD_ROW_INDENT = `calc(${CHEVRON_SLOT_WIDTH} + ${GAP})`;

export const ExpandedFolderPlaceholderText = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 1.5rem;
  padding-left: ${DOCUMENT_CHILD_ROW_INDENT};
  color: ${({ theme }) => theme.colors.gray666};
`;

export const DocumentNameCellRoot = styled.span<{ $indented?: boolean }>`
  position: relative;
  display: inline-flex;
  gap: ${GAP};
  align-items: center;
  min-height: ${CHEVRON_SLOT_WIDTH};
  padding-left: ${({ $indented }) =>
    $indented ? DOCUMENT_CHILD_ROW_INDENT : '0'};

  /* Table cells are taller than this flex; middle-align so empty slots don't sit high. */
  vertical-align: middle;
`;

export const ChevronSlot = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${CHEVRON_SLOT_WIDTH};
  min-height: ${CHEVRON_SLOT_WIDTH};
`;

export const DocumentRowIcon = styled.span<{ $variant: 'folder' | 'file' }>`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${ICON_SIZE};
  min-height: ${ICON_SIZE};
  color: ${({ theme, $variant }) =>
    $variant === 'file' ? theme.colors.builderBlue : theme.colors.gray666};

  svg {
    display: block;
    font-size: ${ICON_SIZE};
  }
`;

export const FileDragHandle = styled.span<{ $indented?: boolean }>`
  position: absolute;
  left: ${({ $indented }) =>
    $indented ? `calc(${DOCUMENT_CHILD_ROW_INDENT} - 1.25rem)` : '-1.25rem'};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 100%;
  color: ${({ theme }) => theme.colors.gray666};
  pointer-events: none;
  opacity: 0;

  tr:hover &,
  tr[data-dragging='true'] & {
    opacity: 1;
  }

  svg {
    display: block;
    width: 0.75rem;
    height: 1.25rem;
  }
`;
